module.exports = __webpack_public_path__ + "img/avatar-8.39202618.png";